import { createRoot } from "react-dom/client";
import * as amplitude from '@amplitude/unified';
import App from "./App.tsx";
import "./index.css";

amplitude.initAll('0cd6f19ed57c25ca15e5e2829fb3d9fe', {
  analytics: { autocapture: true },
  sessionReplay: { sampleRate: 1 },
});

createRoot(document.getElementById("root")!).render(<App />);
